import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";

// Data
import routes from "../shared/routes";

class Body extends Component {
	render() {
		return (
			<div className="main-body">
				<Switch>
					{routes.map(({ component: Cmp, ...route }, i) => {
						// Render the route with the correct path chosen via `react-router-dom` <Switch>
						//
						// We will also pass any props defined in the route object's "props",
						// This might be a collection of props such as translation key for the page, etc
						return (
							<Route
								key={i}
								{...route}
								render={props => <Cmp {...props} {...route.props} />}
							/>
						);
					})}
				</Switch>
			</div>
		);
	}
}

export default Body;



// WEBPACK FOOTER //
// ./src/components/Body.js